import { createRoot } from 'react-dom/client';
import { 
  createBrowserRouter, 
  RouterProvider,
  createRoutesFromElements,
  Route
} from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import AuthGuard from './components/AuthGuard';
import MobileLayout from './components/MobileLayout';
import Home from './pages/Home';
import Auth from './pages/Auth';
import AuthCallback from './pages/auth/callback';
import ResetPassword from './pages/ResetPassword';
import UpdatePassword from './pages/auth/UpdatePassword';
import ValidateSecondEmail from './pages/auth/ValidateSecondEmail';
import Communities from './pages/Communities';
import CommunityDetails from './pages/CommunityDetails';
import UserProfile from './pages/UserProfile';
import Marketplace from './pages/Marketplace';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import Events from './pages/Events';
import OnboardingIndex from './pages/onboarding';
import OnboardingName from './pages/onboarding/Name';
import OnboardingProfession from './pages/onboarding/Profession';
import OnboardingContact from './pages/onboarding/Contact';
import OnboardingLocation from './pages/onboarding/Location';
import OnboardingExperience from './pages/onboarding/Experience';
import OnboardingGoals from './pages/onboarding/Goals';
import OnboardingTerms from './pages/onboarding/Terms';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<App />}>
      {/* Public Routes */}
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/validate-second-email" element={<ValidateSecondEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/update-password" element={<UpdatePassword />} />

      {/* Protected Routes */}
      <Route element={<AuthGuard><MobileLayout /></AuthGuard>}>
        <Route path="/" element={<Home />} />
        <Route path="/communities" element={<Communities />} />
        <Route path="/communities/:id" element={<CommunityDetails />} />
        <Route path="/users/:id" element={<UserProfile />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/events" element={<Events />} />
      </Route>

      {/* Onboarding Routes */}
      <Route element={<AuthGuard><MobileLayout hideNav /></AuthGuard>}>
        <Route path="/onboarding" element={<OnboardingIndex />} />
        <Route path="/onboarding/name" element={<OnboardingName />} />
        <Route path="/onboarding/profession" element={<OnboardingProfession />} />
        <Route path="/onboarding/contact" element={<OnboardingContact />} />
        <Route path="/onboarding/location" element={<OnboardingLocation />} />
        <Route path="/onboarding/experience" element={<OnboardingExperience />} />
        <Route path="/onboarding/goals" element={<OnboardingGoals />} />
        <Route path="/onboarding/terms" element={<OnboardingTerms />} />
      </Route>
    </Route>
  ),
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  }
);

createRoot(document.getElementById('root')!).render(
  <RouterProvider router={router} />
);

serviceWorkerRegistration.register();